


















import {Component, Vue} from 'vue-property-decorator'
import NetworkToggle from '@/components/NetworkToggle.vue'
import {
  TWalletNetwork,
  WALLET_NETWORKS,
} from '@/model/wallets/types/WalletNetwork'
import {NetworkModeHelper} from '@/helpers/NetworkModeHelper'

@Component({
  components: {NetworkToggle},
})
export default class NetworkModeBar extends Vue {
  networks = WALLET_NETWORKS

  get network(): TWalletNetwork {
    return NetworkModeHelper.network()
  }

  switchTo(network: TWalletNetwork) {
    NetworkModeHelper.switchTo(network, this.$route?.name)
  }
}
